import axios from 'axios'

import { toast } from 'helperLibraries/index'
import { SET_LOADER, SET_USER } from './types'
import { identifyUser } from '../../tracking/trackingScripts'
import Bugsnag from '@bugsnag/js'

const dispatchAction = (type, payload, dispatch) =>
  dispatch({ type, payload })

function checkUnauthorized(errorStatus) {
  return errorStatus === 401
}

const EMPTY_USER = {}

/**
 * set user
 * @param {{}} params
 * @param {{}} [params.user=EMPTY_USER] defaults to empty user so we get redirected to login
 * @param {function} params.dispatch
 */
function setUser({ user = EMPTY_USER, dispatch }) {
  dispatchAction(SET_USER, user, dispatch)
  dispatchAction(SET_LOADER, { isLoad: false }, dispatch)
}

const fetchCurrentUser = (history) => async (dispatch, getState) => {
  let user
  dispatchAction(SET_LOADER, { isLoad: true }, dispatch)
  try {
    const { data } = await axios.get('/api/user', {
      headers: { Pragma: 'no-cache' },
      withCredentials: true,
    })
    user = data
    setUser({ user, dispatch })
    // organized data for product tracking
    let isProduction = process.env.NODE_ENV === 'production'
    if (user) {
      const {
        id,
        firstName,
        lastName,
        email,
        isAdmin,
        isInternal,
        accountId,
        accountName,
        isReadOnlyUser,
        isDataOnlyUser,
        isAutomatedSurveyUser,
        commandBarHmac,
      } = user
      const trackingData = {
        name: `${firstName} ${lastName}`,
        email,
        isAdmin,
        isInternal,
        accountId,
        accountName,
        isReadOnlyUser,
        isDataOnlyUser,
        isAutomatedSurveyUser,
        commandBarHmac,
      }
      window?.CommandBar?.addRecords(
        'portfolios',
        user?.portfolios || [],
        {
          renderOptions: {
            labelKey: 'name',
          },
        },
      )

      if (user.isAdmin) {
        window?.CommandBar?.addCallback('manageUsers', () => {
          history.push('/my-account/manage-users')
        })
      }

      window?.CommandBar?.addRecords(
        'isAutomatedSurveyUser',
        isAutomatedSurveyUser || false,
      )
      window?.CommandBar?.addRecords('isAdmin', isAdmin || false)
      identifyUser(id, trackingData, isProduction)
    }

    const shouldDefaultToSiteVisit =
      user?.isAdmin || user?.isGhostUser || user?.isDataOnlyUser

    const isDefaultRoute =
      window?.location?.pathname === '/' ||
      window?.location?.pathname === '/onboarding'

    if (isDefaultRoute) {
      if (shouldDefaultToSiteVisit) {
        history?.push('/site-visit/all')
      } else {
        history?.push('/text/conversations')
      }
    }
  } catch (error) {
    const errorStatus = error?.response?.status
    const isUnauthorized = checkUnauthorized(errorStatus)

    if (isUnauthorized) {
      Bugsnag.leaveBreadcrumb(
        'Unauthorized or no user, redirected to login',
      )
    } else {
      toast.error(
        'There was an error communicating with our servers.  Please reach out to help@theresidesk.com',
      )
      Bugsnag.notify(error)
      console.error(error)
    }

    //  spoof an empty user so we get redirected to login
    setUser({ user: {}, dispatch: dispatch })
  }
}
export default fetchCurrentUser
